/**
 * Debounces foreground/visibility-triggered refresh work so multiple providers
 * (daily summary, network recovery, etc.) do not all fire at once.
 */

import { markSessionForegroundRecovery } from "@/lib/client/sessionPerformanceMarks";

const FOREGROUND_RECOVERY_DEBOUNCE_MS = 3_000;

let lastForegroundRecoveryAt = 0;

/**
 * Runs `fn` at most once per debounce window. Returns whether the job ran.
 */
export function tryRunForegroundRecovery(
  jobId: string,
  fn: () => void,
): boolean {
  const now = Date.now();
  if (now - lastForegroundRecoveryAt < FOREGROUND_RECOVERY_DEBOUNCE_MS) {
    return false;
  }
  lastForegroundRecoveryAt = now;
  markSessionForegroundRecovery(jobId);
  fn();
  return true;
}

/** @internal Resets debounce state for unit tests. */
export function resetForegroundRecoveryCoordinatorForTests(): void {
  lastForegroundRecoveryAt = 0;
}
